import { render } from "./Separator.vue?vue&type=template&id=92a39f94"
import script from "./Separator.js?vue&type=script&lang=js"
export * from "./Separator.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__